<template>
  <div>
    <b-row>
      <b-col>
        <div class="avatar-container">
          <img
            :src="sistemurl + image"
            @click="onClick(image)"
            @error="errorImage"
          />
        </div>
 
      </b-col>
    </b-row>

    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="lg"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" @error="errorImage" />
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../store/store";
import state from "../../../store/state";
export default {
  data() {
    return {
      STOKADI: "",
      sistemurl: Store.state.imgurl,
      image: "",
      imageLink: "",
    };
  },
  methods: {
    errorImage(e) {  
      if (e.type == "error") e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg"
    },
    onClick(event) {
      // alert("lalalala"+event)
      this.imageLink = this.sistemurl + event;
      this.$refs["modal-resim"].show();
    },
    gelenData() {
      this.STOKADI = this.params.data.productCode;
      this.image = this.params.data.image;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
<style>
.avatar-container {
  display: inline-block;
  margin: 5px;
  border-radius: 50%;
  overflow: hidden;
  width: 50px; /* İhtiyacınıza göre boyutu ayarlayın */
  height: 50px; /* İhtiyacınıza göre boyutu ayarlayın */
}

.avatar-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-error {
  background-color: white;
  width: 50px; /* İhtiyacınıza göre boyutu ayarlayın */
  height: 50px; /* İhtiyacınıza göre boyutu ayarlayın */
}
</style>